// extracted by mini-css-extract-plugin
export default {"container":"UserList_container__7o8mQ","list":"UserList_list__yjk2p","onlySelectedSwitch":"UserList_onlySelectedSwitch__ifnRG"};